import React, { useEffect, useRef, useState } from 'react';
import {
  INQUIRY_EMBED_TITLE,
  INQUIRY_EMBED_URL,
  INQUIRY_HOSTED_URL,
  INQUIRY_LOAD_TIMEOUT_MS,
  INQUIRY_MAILTO,
  isUnverifiedIosNotionClient,
} from '../../data/inquiryForm';

const linkClass =
  'text-blue-600 underline hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow';

const InquiryEmbed = ({
  hostedUrl = INQUIRY_HOSTED_URL,
  embedUrl = INQUIRY_EMBED_URL,
  mailto = INQUIRY_MAILTO,
  timeoutMs = INQUIRY_LOAD_TIMEOUT_MS,
}) => {
  const [preferHosted, setPreferHosted] = useState(() => isUnverifiedIosNotionClient());
  const [embedFailed, setEmbedFailed] = useState(false);
  const loadedRef = useRef(false);
  const timerRef = useRef(null);

  useEffect(() => {
    setPreferHosted(isUnverifiedIosNotionClient());
  }, []);

  useEffect(() => {
    if (preferHosted) {
      return undefined;
    }

    timerRef.current = window.setTimeout(() => {
      if (!loadedRef.current) {
        setEmbedFailed(true);
      }
    }, timeoutMs);

    return () => window.clearTimeout(timerRef.current);
  }, [preferHosted, timeoutMs]);

  const handleLoad = () => {
    loadedRef.current = true;
    window.clearTimeout(timerRef.current);
    setEmbedFailed(false);
  };

  const handleError = () => {
    window.clearTimeout(timerRef.current);
    setEmbedFailed(true);
  };

  return (
    <div id="contact-form">
      <p className="text-sm text-gray-600 mb-2">The form below is hosted by Notion.</p>
      <p className="text-sm text-gray-600 mb-4">
        {preferHosted
          ? 'On this device, open the hosted form rather than an in-page embed. '
          : null}
        If the form does not appear,{' '}
        <a href={hostedUrl} target="_blank" rel="noopener noreferrer" className={linkClass}>
          open it on Notion
        </a>{' '}
        or{' '}
        <a href={mailto} className={linkClass}>
          email info@datarook.com
        </a>
        .
      </p>
      {preferHosted ? (
        <p className="text-sm text-gray-500 mb-3">
          <a href={hostedUrl} target="_blank" rel="noopener noreferrer" className={linkClass}>
            Open the website inquiry form
          </a>
        </p>
      ) : (
        <>
          {embedFailed ? (
            <p className="text-sm text-gray-500 mb-3" aria-live="polite">
              If the form looks stuck, open it on Notion or email us.
            </p>
          ) : null}
          <iframe
            src={embedUrl}
            width="100%"
            height="600"
            frameBorder="0"
            title={INQUIRY_EMBED_TITLE}
            onLoad={handleLoad}
            onError={handleError}
          />
        </>
      )}
    </div>
  );
};

export default InquiryEmbed;
